import { tss } from 'tss-react/mui';

export const useStyles = tss.create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 12,
  },
  switchButton: {
    width: '418px',
    height: '40px',
    borderRadius: '12px',
    textTransform: 'none',
    backgroundColor: '#FFFFFF',
    color: '#1875FF',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '140%',
    letterSpacing: '-0.02em',
    border: '1px solid rgba(24, 117, 255, 0.28)',
    boxShadow: '0px 8px 18px rgba(23, 43, 77, 0.14)',
    '&:hover': {
      backgroundColor: '#F8FBFF',
    },
  },
  layout: {
    backgroundColor: theme.palette.background.default,
    backgroundImage: "url('/overlay.jpg'), url('/bg.jpg')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
}));
